export interface Step2LoadDecisionInput {
    forceReload?: boolean;
    previewMode?: boolean;
    editMode?: boolean;
    comesFromStep1?: boolean;
}

export interface Step2LoadDecision {
    loadFromStep1: boolean;
    loadFromPreview: boolean;
    comesFromStep1: boolean;
}

export function resolveStep2LoadDecision(input: Step2LoadDecisionInput = {}): Step2LoadDecision {
    const forceReload = Boolean(input.forceReload);
    const previewMode = Boolean(input.previewMode);
    const editMode = Boolean(input.editMode);
    const comesFromStep1 = Boolean(input.comesFromStep1);

    const loadFromStep1 = forceReload || (!previewMode && !editMode);

    return {
        loadFromStep1,
        loadFromPreview: !loadFromStep1,
        comesFromStep1
    };
}